import { ClaimMessages, TranslationClaimMessages } from "../interfaces";

export const messages : TranslationClaimMessages = {
  [ClaimMessages.access]: "Acessar",
  [ClaimMessages.activateFutureStatus]: "Status futuro ativo",
  [ClaimMessages.activateStatus]: "Status ativo",
  [ClaimMessages.alter]: "Alterar",
  [ClaimMessages.changeStatus]: "Alterar status",
  [ClaimMessages.changeSupply]: "Alterar insumo",
  [ClaimMessages.commercialDefault]: "Padrão comercial",
  [ClaimMessages.costChangeReminder]: "Lembrete de alteração de custo",
  [ClaimMessages.createCopy]: "Criar cópia",
  [ClaimMessages.delete]: "Excluir",
  [ClaimMessages.export]: "Exportar",
  [ClaimMessages.inactivate]: "Inativar",
  [ClaimMessages.inactivateStatus]: "Status inativo",
  [ClaimMessages.include]: "Incluir",
  [ClaimMessages.print]: "Imprimir",
  [ClaimMessages.technicalDataChangeReminder]: "Lembrete de alteração de dado técnico",
  [ClaimMessages.abramsCurveChangeReminder]: "Lembrete de alteração de curva de Abrams",
  [ClaimMessages.includeLogo]: "Incluir logo",
  [ClaimMessages.deleteLogo]: "Excluir logo",
  [ClaimMessages.download]: "Download",
  [ClaimMessages.alterExternalId]: "Alterar id externo",
  [ClaimMessages.changeAllocations]: "Alterar alocações",
  [ClaimMessages.dispatch]: "Expedir",
  [ClaimMessages.reintegrate]: "Reintegrar",
  [ClaimMessages.cancel]: "Cancelar",
  [ClaimMessages.requestAdjustment]: "Solicitar ajuste",
  [ClaimMessages.approveAdjustment]: "Aprovar ajuste",
  [ClaimMessages.changeLink]: "Alterar vínculo",
  [ClaimMessages.ignoreLink]: "Ignorar vínculo",
  [ClaimMessages.closeInventory]: "Fechar estoque",
  [ClaimMessages.closeProduction]: "Fechar produção",
  [ClaimMessages.reopenProduction]: "Reabrir produção",
  [ClaimMessages.alterDelivery]: "Alterar entrega",
  [ClaimMessages.alterPumping]: "Alterar bombeamento",
  [ClaimMessages.alterScheduling]: "Alterar programação",
  [ClaimMessages.approveDisapprovePendingRequests]: "Aprovar/Reprovar pedidos pendentes",
  [ClaimMessages.changeDeliveryRoute]: "Alterar rota de entrega",
  [ClaimMessages.reopenInventory]: "Reabrir estoque",
  [ClaimMessages.dispatchPumpingTicket]: "Expedir remessa de bombeamento",
  [ClaimMessages.waterCut]: "Corte d'água",
  [ClaimMessages.sendToAutomation]: "Enviar para automação",
  [ClaimMessages.creditLimitWebserviceResendForAnalysis]: "Reenviar análise de limite de crédito",
  [ClaimMessages.alertsPageAccess]: "Página de Alertas - Acessar",
  [ClaimMessages.clientPrepaidAlter]: "Cliente pré-pago - Alterar",
  [ClaimMessages.constructionNotFoundAlter]: "Obra não encontrada - Alterar",
  [ClaimMessages.constructionExpiredAlter]: "Obra expirada - Alterar",
  [ClaimMessages.schedulingWithoutExternalIdAlter]: "Programação sem ID externo - Alterar",
  [ClaimMessages.supplyNotAuthorizedBySecurityVisitAlter]: "Insumo não autorizado por visita de segurança - Alterar",
  [ClaimMessages.productWithoutQuotationAlter]: "Produto sem cotação - Alterar",
  [ClaimMessages.productOrRecipeInactiveAlter]: "Produto ou receita inativa - Alterar",
  [ClaimMessages.clientDelinquentAlter]: "Cliente inadimplente - Alterar",
  [ClaimMessages.clientExpiredCreditDateAlter]: "Data de crédito do cliente expirada - Alterar",
  [ClaimMessages.clientWithoutCreditLimitAlter]: "Cliente sem limite de crédito - Alterar",
  [ClaimMessages.waitingCreditLimitAnalysisAlter]: "Aguardando análise de limite de crédito - Alterar",
  [ClaimMessages.plantUnavailableAlter]: "Central indisponível - Alterar",
  [ClaimMessages.closeScheduling]: "Fechar Programação",
  [ClaimMessages.reopenScheduling]: "Reabrir Programação",
  [ClaimMessages.blockReasonCreditLimitValidation]: "Validação de limite de crédito",
  [ClaimMessages.blockReasonCreditLimitAnalysis]: "Aguardando análise de limite de crédito",
  [ClaimMessages.blockReasonProductGroupRequiresApproval]: "Grupo de produto requer aprovação",
  [ClaimMessages.blockReasonNotSentForAutomation]: "Não enviado para automação",
  [ClaimMessages.blockReasonProductRequiresApproval]: "Produto requer aprovação",
  [ClaimMessages.blockReasonProductTypeRequiresApproval]: "Tipo de produto requer aprovação",
  [ClaimMessages.blockReasonSupplyDeviation]: "Desvio de insumo",
  [ClaimMessages.blockReasonSupplyGroupDeviation]: "Desvio de grupo de insumo",
  [ClaimMessages.blockReasonMissingAutomationResponse]: "Resposta da automação ausente",
  [ClaimMessages.blockReasonInsufficientStock]: "Estoque insuficiente",
  [ClaimMessages.blockReasonGravelNoLoadReuseParamSet]: "Brita sem parâmetro de reaproveitamento definido",
  [ClaimMessages.blockReasonProductGroupNoLoadReuseParamSet]: "Grupo de produto sem parâmetro de reaproveitamento definido",
  [ClaimMessages.blockReasonProductNoLoadReuseParamSet]: "Produto sem parâmetro de reaproveitamento definido",
  [ClaimMessages.blockReasonProductGroupReuseOutOfParams]: "Grupo de produto fora dos parâmetros de reaproveitamento",
  [ClaimMessages.blockReasonProductReuseOutOfParams]: "Produto fora dos parâmetros de reaproveitamento",
  [ClaimMessages.blockReasonGravelReuseOutOfParams]: "Brita fora dos parâmetros de reaproveitamento",
  [ClaimMessages.blockReasonDivergentVolume]: "Volume divergente",
  [ClaimMessages.blockReasonWaitingCreditLimitAnalysis]: "Aguardando análise de limite de crédito",
  [ClaimMessages.blockReasonExpiredCreditDate]: "Data de crédito expirada",
  [ClaimMessages.inconsistencyActualSlump]: "Slump atual",
  [ClaimMessages.inconsistencyConcreteMixerSchedules]: "Horários de betoneiras",
  [ClaimMessages.inconsistencyWaterAddedInConstruction]: "Água adicionada na obra",
  [ClaimMessages.inconsistencyOdometer]: "Odômetro",
  [ClaimMessages.inconsistencyHourMeter]: "Horímetro",
  [ClaimMessages.inconsistencyPumpScheduleWithoutDeliveryTicketPump]: "Programações com bomba sem ticket de entrega",
  [ClaimMessages.inconsistencyPumpScheduleMissingM3ToIssueDelivery]: "Quantidade emitida difere da quantidade programada",
  [ClaimMessages.inconsistencyUndeliveredAndUncancelledSchedules]: "Programações não entregues e não cancelados",
  [ClaimMessages.inconsistencyUndeliveredAndUncancelledDeliveries]: "Entregas não realizadas e não canceladas",
  [ClaimMessages.inconsistencyUnlinkedWeighings]: "Pesagens não vinculadas",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentNotSend]: "Documento fiscal não enviado",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentNoAnswer]: "Documento fiscal sem resposta",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentWithRejection]: "Documento fiscal com rejeição",
  [ClaimMessages.inconsistencyAdditionalModifications]: "Modificações adicionais",
  [ClaimMessages.inconsistencyLoadTicketWithoutDeliveryTicket]: "Ticket de pesagem sem remessa emitida",
  [ClaimMessages.viewReports]: "Visualizar Relatórios",
  [ClaimMessages.registerExecution]: "Registrar Execução",
  [ClaimMessages.updateExecution]: "Atualizar Execução",
  [ClaimMessages.deleteExecution]: "Excluir Execução",
  [ClaimMessages.completeTask]: "Concluir Tarefa",
  [ClaimMessages.addNotes]: "Adicionar Notas",
  [ClaimMessages.viewPlantStatus]: "Visualizar Status da Planta",
  [ClaimMessages.viewProduction]: "Visualizar Produção",
  [ClaimMessages.viewAlarms]: "Visualizar Alarmes",
  [ClaimMessages.manualCommand]: "Comando Manual",
  [ClaimMessages.adjustOrders]: "Ajustar Pedidos",
  [ClaimMessages.acknowledgeAlarm]: "Reconhecer Alarme",
  [ClaimMessages.authorizePrivileged]: "Autorizar Privilegiado",
  [ClaimMessages.manageLocalUsers]: "Gerenciar Usuários Locais",
  [ClaimMessages.viewAudit]: "Visualizar Auditoria",
  [ClaimMessages.plantDefinition]: "Definição de Planta",
  [ClaimMessages.inconsistencyLoadReuseWithoutDestination]: "Reaproveitamentos sem destino informado",
  [ClaimMessages.manualEntry]: "Lançamento Manual",
  [ClaimMessages.alterApplicationOfOwnLabor]: "Editar aplicação de mão de obra própria no bombeamento",
  [ClaimMessages.adjustedStrength]: "Resultado ajustado do rompimento",
  [ClaimMessages.excludeRuptureFromStatistics]: "Excluir rompimento das estatísticas",
  [ClaimMessages.alterProductWeighted]: "Alterar traço a ser pesado"
};
